export default function AboutSection() {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <p className="font-label text-sm tracking-widest uppercase text-secondary-600 mb-4">About</p>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-900 leading-tight">
              Engineering the future of digital experiences
            </h2>
            <div className="w-12 h-px bg-accent-400 mt-6"></div>
          </div>
          <div className="lg:col-span-7">
            <div className="space-y-6">
              <p className="font-body text-foreground-700 text-base md:text-lg leading-relaxed">
                The company is a professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies. It builds scalable, maintainable, and high-performance systems with a strong focus on usability, stability, and long-term technical quality.
              </p>
              <p className="font-body text-foreground-700 text-base md:text-lg leading-relaxed">
                The team follows modern software engineering practices, including clean architecture, performance optimization, and user-centered design. The company emphasizes continuous innovation, improvement of development workflows, and adoption of up-to-date engineering standards to deliver reliable and future-ready IT solutions.
              </p>
              <p className="font-body text-foreground-700 text-base md:text-lg leading-relaxed">
                It actively explores new technologies and evolves its internal processes to maintain high technical excellence. Every project is approached with precision, discipline, and a deep understanding of the platforms and technologies involved.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-12">
              <div className="p-6 bg-background-100 rounded-lg">
                <div className="w-10 h-10 flex items-center justify-center mb-4">
                  <i className="ri-smartphone-line text-2xl text-accent-500"></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-2">iOS Platform</h3>
                <p className="font-body text-sm text-foreground-600 leading-relaxed">Deep specialization in native platform development and ecosystem integration.</p>
              </div>
              <div className="p-6 bg-background-100 rounded-lg">
                <div className="w-10 h-10 flex items-center justify-center mb-4">
                  <i className="ri-stack-line text-2xl text-accent-500"></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-2">Scalable Systems</h3>
                <p className="font-body text-sm text-foreground-600 leading-relaxed">Architectures designed for growth, reliability, and maintainability over time.</p>
              </div>
              <div className="p-6 bg-background-100 rounded-lg">
                <div className="w-10 h-10 flex items-center justify-center mb-4">
                  <i className="ri-shield-check-line text-2xl text-accent-500"></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-2">Technical Quality</h3>
                <p className="font-body text-sm text-foreground-600 leading-relaxed">Rigorous standards for code quality, testing, and long-term system health.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}